import { axInst } from "../Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("/retails/filter", {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const regionsArray = data?.filter_data.REGION.buckets.map((e) => e.key);
  // .filter((e) => e !== "All Regions");
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const statesArray = data?.filter_data.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const statesOfficeArray = data?.filter_data.STATE_OFFICE.buckets.map(
    (e) => e.key
  );
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesOfficeArray;
};

//DealerName
export const fetchDealer = async (pRegion, pState, pStateOffice) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const DealerArray = data?.filter_data.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const dealercodeArray = data?.filter_data.DEALER_CODE.buckets.map(
    (e) => e.key
  );
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sorteddealercodeArray;
};

//Division
export const fetchDivision = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const DivisionArray = data?.filter_data.DIVISION_NAME.buckets.map(
    (e) => e.key
  );
  const sortedDivisionArray = DivisionArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDivisionArray;
};

//ProductLine
export const fetchProductLine = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const productLineArray = data?.filter_data.PRODUCT_LINE.buckets.map(
    (e) => e.key
  );
  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });

  const lobArray = data?.filter_data.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedLobArray;
};

//ppl
export const fetchPPL = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  });
  const pplArray = data?.filter_data.PPL.buckets.map((e) => e.key);
  const sortedPPLArray = pplArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedPPLArray;
};

//pl
export const fetchPL = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob,
  pPpl
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: [],
    regulator_Name: [],
  });
  const plArray = data?.filter_data.PL.buckets.map((e) => e.key);
  const sortedPLArray = plArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedPLArray;
};

//regulator
export const fetchRegulator = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob,
  pPpl,
  pPl
) => {
  const { data } = await axInst.post("/retails/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: pPl || [],
    regulator_Name: [],
  });
  const regulatorArray = data?.filter_data.REGULATORY_NORMS.buckets
    .map((e) => e.key)
    .filter((e) => e !== "");
  const sortedRegulatorArray = regulatorArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedRegulatorArray;
};
